import * as R from 'ramda';
import Payment from 'payment';
import { validate } from 'validate.js';

import { dateIsValid } from 'utils/format';
import { getIn } from 'utils/ramda';
import moment from 'moment';

export const validateRequired = ({ message = 'must be filled' } = {}) => (value) =>
  (R.isNil(value) ? message : undefined);

export const validatePayPalRequired = () => (value) => {
  if (value === 'invalid') return 'Card expiry is invalid';
  if (value === 'empty') return 'must be filled';
  return undefined;
};

export const validateEmpty = ({ message = 'must be filled' } = {}) => (value) =>
  (R.isEmpty(value) ? message : undefined);

export const validateRequiredNotStrict = ({ message = 'must be filled' } = {}) => (value) =>
  (value === undefined ? message : undefined);

export function validateAccepted({ message = 'must be accepted' } = {}) {
  return (value) => (value === true || value === 'true' ? undefined : message);
}

export const validateEquality = ({ message, base = true } = {}) => (value) => {
  const mess = message || `must be equal ${base.toString()}`;
  return value === base ? undefined : mess;
};

export function validateEmail({ message = 'is invalid' } = {}) {
  return (email) => validate.single(email, { email: { message } });
}

export const validatePhone = ({ message = 'is invalid' } = {}) => (phone) => {
  const onlyNums = phone ? phone.replace(/[^\d]/g, '') : undefined;

  if (!onlyNums) return undefined;
  if (onlyNums.length !== 10) return message;
  if (onlyNums.startsWith('1')) return message;
  return undefined;
};

export const validateDate = ({ message = 'is invalid' } = {}) => (date) => {
  if (dateIsValid(date)) return undefined;
  return message;
};

export const validateCardNumber = ({ message = 'Card number is invalid' } = {}) => (cardNumber) => {
  if (Payment.fns.validateCardNumber(cardNumber)) return undefined;
  return message;
};

export const validateCardCVV = ({ message = 'Card CVV is invalid', cardNumberPath } = {}) => (cardCVV, allValues) => {
  let issuer = null;
  if (cardNumberPath) {
    const cardNumber = getIn(cardNumberPath, allValues);
    issuer = Payment.fns.cardType(cardNumber);
  }
  if (Payment.fns.validateCardCVC(cardCVV, issuer)) return undefined;
  return message;
};

export const validateCardExpiryMonth = ({ message = 'Card expiry is invalid', yearPath } = {}) => (
  month,
  allValues,
) => {
  let year = null;
  if (yearPath) {
    year = getIn(yearPath, allValues);
  }
  if (Payment.fns.validateCardExpiry(month, year)) return undefined;
  return message;
};

export const validateCardExpiryYear = ({ message = 'Card expiry is invalid', monthPath } = {}) => (year, allValues) => {
  let month = null;
  if (monthPath) {
    month = getIn(monthPath, allValues);
  }
  if (Payment.fns.validateCardExpiry(month, year)) return undefined;
  return message;
};

export const validateCardExpiryDate = ({ message = 'Card expiry date is invalid' } = {}) => (expiryDate) => {
  if (!expiryDate || expiryDate.trim() === '') {
    return undefined;
  }
  const expiryDateTransformed = moment(expiryDate, 'MM/YY');

  const month = expiryDateTransformed.month() + 1;
  const year = expiryDateTransformed.year();

  if (!Payment.fns.validateCardExpiry(month.toString(), year.toString())) {
    return message;
  }

  return undefined;
};

export const composeValidators = (...validators) => (...args) =>
  validators.reduce((error, validator) => error || validator(...args), undefined);

export const validateRequiredByConditon = ({ message = 'must be filled', isRequired } = {}) => (value) =>
  (isRequired && R.isNil(value) ? message : undefined);


export const validateUSAZipCode = ({ message = 'Must be in one of the following formats: 12345 or 12345-1234', countryCodePath } = {}) => (value, allValues) => {
  const countryCode = getIn(countryCodePath, allValues)

  const zipCodePattern = /^\d{5}(-\d{4})?$/;
  if (value && countryCode == 'US' && !zipCodePattern.test(value)) {
    return message;
  }
  return undefined;
};
